import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register PWA service worker with auto-update handling
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js?v=9')
      .then(reg => {
        console.log('Service Worker registered successfully:', reg.scope);
        // Check for updates whenever tab becomes visible / active
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible' && reg) {
            reg.update().catch(() => {});
          }
        });
        // Check for service worker updates periodically
        if (reg) {
          reg.onupdatefound = () => {
            const installingWorker = reg.installing;
            if (installingWorker) {
              installingWorker.onstatechange = () => {
                if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  console.log('New update available for DinexaPOS PWA.');
                }
              };
            }
          };
        }
      })
      .catch(err => console.log('Service Worker registration failed:', err));
  });
}

